import { ref, createContext, reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { search_cliente, fixImageCliente, invoice_list, logout } from '@/plugins/odoo'
import { search_type_system } from './odoo';
import { checkRouteBCV } from '@/plugins/bcv';

const route = ref(null);
const contentHeight = ref('');
const breakpoints = {
    xs: 480,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
}
const isLoading = ref(false);
const messageText = ref('')

const sidebarOptions = reactive({
    collapsed: true,
    width: '50em'
});

const profileDrawer = reactive({
    show: false
})

const getContentHeight = () => {
    // console.log(window.innerWidth, this.breakpoints.sm, this.breakpoints.md)
    if (window.innerWidth <= breakpoints.sm) {
        contentHeight.value = "674px";
    } else if (window.innerWidth <= breakpoints.lg) {
        contentHeight.value = "245px";
    } else {
        contentHeight.value = "";
    }
    localStorage.setItem('contentHeight', contentHeight.value);
    return contentHeight;
}
const setupResizeListener = () => {
    getContentHeight(); // Llamamos al método inicialmente para establecer el tamaño de fondo
    window.addEventListener('resize', getContentHeight);
}
const removeResizeListener = () => {
    window.removeEventListener('resize', () => {});
}
const toggleSidebar = (value) => {
    if (contentHeight.value !== "") {
        // console.log("e =>" + value)
        sidebarOptions.collapsed = value
    }
}
const redirect_logout = () => {
    console.log("Username NO VALID")
    // clearInterval(this.interval)
    // clearInterval(this.interval2)
    localStorage.clear();
    // const router = useRouter();
    // router.replace('/login');
    logout();
}

const toggleProfileDrawer = (value) => {
    profileDrawer.show = value;
}

const inteval_profile = () => {
    // return setInterval(() => {
    //     fetchProfileData();
    // }, 5000);
    fetchProfileData();
}
const verificarDatos = async (route, typeCheck = "Portal") => {
    if (route.meta.typeUser == typeCheck) { 
        console.log("INICIA VERFICACION")
        await fetchProfileData(route) 
        const totalProfile =  (typeCheck == "Portal") ? route.meta.myCliente.length : route.meta.mySystem.length;
        if (totalProfile == 0) {
            console.log("NO AUTORIZADO, NO LO ENCONTRE")
            route.meta.typeUser = "";
            route.meta.typeRoute = "";
            return false
        } else {
            route.meta.typeRoute = localStorage.getItem('typeRouter');                
            return true
        }
    } else {
      console.log("NO AUTORIZADO");
      return false;
    } 
}
const fetchProfileData = async (myRoute = false) => {
    const token_portal = (localStorage.getItem('token_portal') !== null) ? localStorage.getItem('token_portal') : false;
    const authCRM = (localStorage.getItem('authCRM') !== null) ? localStorage.getItem('authCRM') : false;
    if (myRoute != false) {
        console.log("ROUTE PROFILE DATA")
        route.value = myRoute
    } else {
        console.log("NO ROUTE PROFILE DATA")
        route.value = useRoute()
    }
    // console.log(route.value.meta, token_portal, authCRM)
    if (!token_portal || !authCRM) {
        redirect_logout()
    } else {
        // getContentHeight();
        if (route.value.meta.layout == "system") {
            console.log("sistema")
            await refreshMetaSystem(authCRM);
        } else {
            console.log("cliente")
            await refreshMetaClient(authCRM);
        }
        console.log("llegue")
    }
}
const activeClient = (route) => {
    if (route.meta.typeRoute == undefined) {
        route.meta.typeRoute = localStorage.getItem('typeRouter');
    } else {
        localStorage.setItem('typeRouter', route.meta.typeRoute);
    }
    localStorage.setItem('token_portal', true);
    localStorage.setItem('authCRM', route.meta.authCRM);
  }
const refreshMeta = (authCRM) => {
    // console.log(router)
    if (route != false) {
        route.value.meta.token_portal = true;
        route.value.meta.authCRM = authCRM;
        route.value.meta.breakpoints = breakpoints;
        isLoading.value = route.value.meta.toggleLoading;
    } else {
        console.log("NO ROUTE")
    }
    localStorage.setItem('token_portal', true);
}

const refreshMetaClient = async (authCRM) => {
    const result = await search_cliente();
    // console.log(typeof(result.data))
    if (result.data && result.data.length > 0) {
        refreshMeta(authCRM)
        route.value.meta.myCliente = result.data;
        route.value.params.myCliente = result.data;
        route.value.meta.myCliente[0].avatar_128 = fixImageCliente(route.value.meta.myCliente[0].avatar_128)
        route.value.meta.myCliente[0].avatar_512 = fixImageCliente(route.value.meta.myCliente[0].avatar_512)
        // if (route.value.meta.invoices.length == 0) {
            route.value.meta.invoices = await invoice_list(result.data[0].id);
        // } 
    } else {
        redirect_logout()
    }
}

const refreshMetaSystem = async (authCRM) =>  {
    const result = await search_type_system();
    if (result.data && Object.keys(result.data).length > 0 && result.data.type_route) {   
        refreshMeta(authCRM)
        route.value.meta.mySystem = result.data
        route.value.meta.typeRoute = result.data.type_route
        localStorage.setItem('typeRouter', result.data.type_route)
    } else {
        redirect_logout()
    }
}

const refreshBCV = async (myRoute = false) => {
    if (myRoute != false) {
        // console.log("ROUTE PROFILE DATA")
        route.value = myRoute
    } else {
        // console.log("NO ROUTE PROFILE DATA")
        route.value = useRoute()
    }
    const bcv_usd = await checkRouteBCV(route.value)
    if (bcv_usd > 0) {
        route.value.meta.bcv_usd = bcv_usd;
    } else {
        route.value.meta.bcv_usd = 0;
    }
  }

export { 
    route,
    sidebarOptions,
    profileDrawer, 
    isLoading, 
    breakpoints, 
    contentHeight, 
    messageText,
    getContentHeight, 
    toggleSidebar, 
    setupResizeListener, 
    removeResizeListener,
    redirect_logout, 
    toggleProfileDrawer, 
    verificarDatos,
    fetchProfileData, 
    activeClient,
    inteval_profile ,
    refreshBCV
}